import{useApplicationState}from"../../state";export const setUtmLegacy=utm=>{useApplicationState.getState().attribution.setUtm(utm);};